import { useMutation } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';

import { useAccountsService, UpdateEmployerUserContactParams } from '@restworld/data-services';
import { useAuth } from '@restworld/feature-authentication';

import { useEmployerUserContactsListQueryKey } from './use-employer-user-contacts-list-query';

function useUpdateEmployerUserContact() {
  const queryClient = useQueryClient();
  const employerUserContactListQueryKey = useEmployerUserContactsListQueryKey();
  const accountsService = useAccountsService();
  const { user } = useAuth();

  const mutation = useMutation({
    mutationFn: ({ id, ...restParams }: UpdateEmployerUserContactParams) =>
      accountsService.updateEmployerUserContact({ organization_id: user?.organization_id, ...restParams }, id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: employerUserContactListQueryKey });
    },
  });

  return mutation;
}
export default useUpdateEmployerUserContact;
